document.addEventListener('DOMContentLoaded', function() {
  function updateCartDrawer() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Loop through each item in the cart
        cart.items.forEach(item => {
          // Check for the "Pre-order" property
          const preorderNote = item.properties['Pre-order']; // Adjust property name if needed
          if (preorderNote) {
            // Create a note element
            const noteElement = document.createElement('p');
            noteElement.className = 'preorder-note';
            noteElement.textContent = 'Note: Pre-order item';

            // Find the cart item element in the drawer
            const itemElement = document.querySelector(`.cd-cart-item[data-cart-item="${item.id}"]`);
            if (itemElement) {
              // Append the note element
              itemElement.querySelector('.cd-cart-item-info').appendChild(noteElement);
            }
          }
        });
      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  // Update the cart drawer when it is opened
  const cartDrawer = document.querySelector('#cart-drawer-app .cd-cart');
  if (cartDrawer) {
    cartDrawer.addEventListener('open', updateCartDrawer);
    // Also call it initially if the drawer is already open
    updateCartDrawer();
  }
});
